export default __webpack_public_path__ + "static/media/Do.9f8bdc21.png";